export default __webpack_public_path__ + "static/media/1840.5cd4f7ce.png";